var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "order-detail-dialog",
      attrs: {
        title: "订单详情",
        visible: _vm.visible,
        width: "80%",
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "order-detail-content",
        },
        [
          _c(
            "el-card",
            { staticClass: "detail-section", attrs: { shadow: "never" } },
            [
              _c(
                "div",
                {
                  staticClass: "section-header",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", { staticClass: "section-title" }, [
                    _vm._v("基础信息"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("订单编号："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.orderDetail.orderNo || "-")),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("下单时间："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.orderDetail.orderTime || "-")),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("完结时间："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.orderDetail.completionTime || "-")),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("订单金额："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value amount" }, [
                        _vm._v(
                          "¥" +
                            _vm._s(
                              (
                                _vm.orderDetail.integralAmount +
                                _vm.orderDetail.wxPayAmount
                              ).toFixed(2)
                            )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("客户备注："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value remark" }, [
                        _vm._v(_vm._s(_vm.orderDetail.customerNotes || "-")),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c(
                      "div",
                      { staticClass: "info-item" },
                      [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("订单状态："),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getOrderStatusType(
                                _vm.orderDetail.orderStatus
                              ),
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.orderDetail.orderStatus) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("付款时间："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.orderDetail.paymentTime || "-")),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("取消时间："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.orderDetail.cancellationTime || "-")),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("下单店铺："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.orderDetail.storeName || "-")),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("如遇缺货："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.orderDetail.stockoutPolicy || "-")),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-card",
            { staticClass: "detail-section", attrs: { shadow: "never" } },
            [
              _c(
                "div",
                {
                  staticClass: "section-header",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", { staticClass: "section-title" }, [
                    _vm._v("调价信息"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                  },
                },
                [
                  _c("div", { staticClass: "info-item2" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("调价比例："),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "value",
                        staticStyle: { color: "#818181" },
                      },
                      [_vm._v(_vm._s(_vm.orderDetail.adjustRate || 0) + "%")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item2" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("调价后金额："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _c("span", { staticStyle: { color: "#818181" } }, [
                        _vm._v(
                          "￥" + _vm._s(_vm.orderDetail.afterAdjustAmount)
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item2" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("调价金额："),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "value",
                        staticStyle: { color: "#818181" },
                      },
                      [_vm._v(" ￥" + _vm._s(_vm.orderDetail.adjustAmount))]
                    ),
                  ]),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-card",
            { staticClass: "detail-section", attrs: { shadow: "never" } },
            [
              _c(
                "div",
                {
                  staticClass: "section-header",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", { staticClass: "section-title" }, [
                    _vm._v("支付信息"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                  },
                },
                [
                  _c("div", { staticClass: "info-item2" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("福豆支付："),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "value",
                        staticStyle: { color: "#f56c6c" },
                      },
                      [
                        _vm._v(
                          "￥" + _vm._s(_vm.orderDetail.integralAmount || "-")
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item2" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("会员折扣："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _c("span", { staticStyle: { color: "#f56c6c" } }, [
                        _vm._v("￥" + _vm._s(_vm.orderDetail.discountAmount)),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { color: "#818181" } }, [
                        _vm._v(
                          _vm._s(
                            "(" +
                              (
                                100 -
                                (
                                  (_vm.orderDetail.discountAmount /
                                    (_vm.orderDetail.discountAmount +
                                      _vm.orderDetail.integralAmount +
                                      _vm.orderDetail.wxPayAmount)) *
                                  100
                                ).toFixed(0)
                              )
                                .toString()
                                .replace(0, "") +
                              "折)"
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item2" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("订单实付："),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "value",
                        staticStyle: { color: "#f56c6c" },
                      },
                      [_vm._v("￥" + _vm._s(_vm.orderDetail.wxPayAmount))]
                    ),
                  ]),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-card",
            { staticClass: "detail-section", attrs: { shadow: "never" } },
            [
              _c(
                "div",
                {
                  staticClass: "section-header",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", { staticClass: "section-title" }, [
                    _vm._v("商品明细"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.orderDetail.orderItems || [],
                    border: "",
                    size: "mini",
                    "header-cell-style": { fontWeight: "bold" },
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "productName",
                      label: "商品名",
                      "min-width": "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "salesAttribute",
                      label: "销售属性",
                      width: "100",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "barcode", label: "条形码", width: "120" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "skuId", label: "SKU ID", width: "150" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "skuName",
                      label: "SKU 名称",
                      "min-width": "150",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "quantity",
                      label: "数量",
                      width: "80",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "unitPrice",
                      label: "市场价",
                      width: "100",
                      align: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            ¥" +
                                _vm._s(scope.row.otPrice.toFixed(2) || "0.00") +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "totalPrice",
                      label: "总价",
                      width: "100",
                      align: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            ¥" +
                                _vm._s(
                                  (
                                    scope.row.otPrice * scope.row.quantity
                                  ).toFixed(2) || "0.00"
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "调价后金额",
                      align: "right",
                      width: "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            ¥" +
                                _vm._s(scope.row.afterAdjustPrice.toFixed(2)) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "调价金额", align: "right" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            ¥" +
                                _vm._s(scope.row.adjustAmount.toFixed(2)) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "上浮比例", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  (scope.row.adjustRate * 100).toFixed(2)
                                ) +
                                "%\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "imageUrl",
                      label: "图片",
                      width: "80",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.imageUrl
                              ? _c("el-image", {
                                  staticStyle: {
                                    width: "50px",
                                    height: "50px",
                                  },
                                  attrs: {
                                    src: scope.row.imageUrl,
                                    fit: "cover",
                                  },
                                })
                              : _c("span", [_vm._v("-")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "优惠金额", width: "100", align: "right" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            ¥" +
                                _vm._s(
                                  Number(
                                    scope.row.discountAmount != null
                                      ? scope.row.discountAmount
                                      : scope.row.couponPrice || 0
                                  ).toFixed(2)
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "退款金额", width: "100", align: "right" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            ¥" +
                                _vm._s(
                                  Number(scope.row.refundAmount || 0).toFixed(2)
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.orderDetail.products && _vm.orderDetail.products.length > 0
                ? _c(
                    "div",
                    { staticClass: "expand-section" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.toggleExpand },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.isExpanded ? "收起" : "展开") +
                              "\n          "
                          ),
                          _c("i", {
                            class: _vm.isExpanded
                              ? "el-icon-arrow-up"
                              : "el-icon-arrow-down",
                          }),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-card",
            { staticClass: "detail-section", attrs: { shadow: "never" } },
            [
              _c(
                "div",
                {
                  staticClass: "section-header",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", { staticClass: "section-title" }, [
                    _vm._v("配送信息"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("配送方式："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.orderDetail.deliveryMethod || "-")),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("配送模板："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value template" }, [
                        _vm._v(_vm._s(_vm.orderDetail.deliveryTemplate || "-")),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("打包费："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(
                          "¥" + _vm._s(_vm.orderDetail.packagingFee || "0.00")
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("配送费："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(
                          "¥" + _vm._s(_vm.orderDetail.deliveryFee || "0.00")
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("送达时间："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(
                          _vm._s(_vm.orderDetail.deliveryTimeEstimate || "-")
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("收货人："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.orderDetail.recipientName || "-")),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("收货人手机："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.orderDetail.recipientPhone || "-")),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("配送地址："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.orderDetail.deliveryAddress || "-")),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("配送距离："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.orderDetail.deliveryDistance || "-")),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("取餐时间："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(
                          _vm._s(_vm.orderDetail.deliveryTimeEstimate || "-")
                        ),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-card",
            { staticClass: "detail-section", attrs: { shadow: "never" } },
            [
              _c(
                "div",
                {
                  staticClass: "section-header",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", { staticClass: "section-title" }, [
                    _vm._v("操作日志"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.orderDetail.logs && _vm.orderDetail.logs.length > 0
                ? _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.orderDetail.logs,
                        border: "",
                        size: "mini",
                        "header-cell-style": { fontWeight: "bold" },
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "title",
                          label: "操作标题",
                          width: "180",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "createTime",
                          label: "日期",
                          width: "180",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "content",
                          label: "内容",
                          "min-width": "300",
                        },
                      }),
                    ],
                    1
                  )
                : _c("div", { staticClass: "empty-logs" }, [
                    _c("span", { staticStyle: { color: "#909399" } }, [
                      _vm._v("暂无操作日志"),
                    ]),
                  ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [_c("el-button", { on: { click: _vm.handleClose } }, [_vm._v("关闭")])],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }